export function forbiddenCharactersValidator(value: any, params: any[] | Record<string, any>) {
  const found = (typeof value === "string" ? value : "").match(/[¥'"`,\\]/g)

  // 重複を除いて返す
  return found ? Array.from(new Set(found)) : []
}
